import { createTypes, createAction } from 'lib/action'

const LOAD_NOTIFICATION_SETTING = createTypes('notificationsetting', 'load')
const SAVE_NOTIFICATION_SETTING = createTypes('notificationsetting', 'update')

const loadNotificationSetting = {
  request: (data, loading) =>
    createAction(LOAD_NOTIFICATION_SETTING.REQUEST, { data, loading }),
  success: settings =>
    createAction(LOAD_NOTIFICATION_SETTING.SUCCESS, { settings }),
  failure: () => createAction(LOAD_NOTIFICATION_SETTING.FAILURE),
}

const saveNotificationSetting = {
  request: (data, cb) =>
    createAction(SAVE_NOTIFICATION_SETTING.REQUEST, { data, cb }),
  success: settings =>
    createAction(SAVE_NOTIFICATION_SETTING.SUCCESS, { settings }),
  failure: () => createAction(SAVE_NOTIFICATION_SETTING.FAILURE),
}

export {
  LOAD_NOTIFICATION_SETTING,
  loadNotificationSetting,
  SAVE_NOTIFICATION_SETTING,
  saveNotificationSetting,
}
